import { createMemoStyles } from '@wds/utils';

import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing }: PricingAppTheme) => ({
  Summary: {
    margin: [spacing[8], 'auto', 0],
  },
  PackagesContainer: {
    display: 'grid',
    padding: [0, spacing[3]],
    maxWidth: 350,
    margin: [0, 'auto'],

    [MD_MEDIA_QUERY]: {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '100%',
    },
  },
}));
